import { useEffect } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import HealthSubpageHeader from "../../../components/HealthSubpageHeader"
import HealthSubpageLayout from "../../../components/HealthSubpageLayout"
import HealthActions from "../../../reducer"
import { useBusinessAccountId } from "../../hooks/useBusinessAccountId"
import { useVampHistoricalDataMode } from "../../hooks/useHistoricalDataMode"
import EstimatedProgramStatusTable from "./Table/EstimatedProgramStatusTable"

const EstimatedProgramStatusPage = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const { mainInfo, descriptor, monitoringInitialized } = useSelector((state) => state.health)

  const business_account_id = useBusinessAccountId()
  const { isHistoricalDataMode } = useVampHistoricalDataMode()

  useEffect(() => {
    if (!mainInfo && descriptor) {
      dispatch(
        HealthActions.getHealthMainInfoRequest({
          business_account: business_account_id,
          descriptor,
          ...(isHistoricalDataMode ? { historical_data: true } : {})
        })
      )
    }
  }, [business_account_id, descriptor, isHistoricalDataMode])

  useEffect(() => {
    if (!monitoringInitialized) {
      dispatch(HealthActions.monitoringInit())
    }
  }, [])

  return (
    <HealthSubpageLayout backText={t("Back to Health")}>
      <HealthSubpageHeader title={t("Estimated Program Status")} />
      <EstimatedProgramStatusTable variant="page" withPagination pageSize={10} />
    </HealthSubpageLayout>
  )
}

export default EstimatedProgramStatusPage
